export const PageLoader = () => (
  <div className="container-ab py-24" role="status" aria-live="polite" data-testid="page-loader">
    <div className="h-4 w-32 animate-pulse rounded bg-ab-soft" />
    <div className="mt-6 h-12 w-2/3 animate-pulse rounded bg-ab-soft" />
    <div className="mt-10 grid gap-8 sm:grid-cols-3">{[0, 1, 2].map((i) => <div key={i} className="aspect-[16/11] animate-pulse rounded-2xl bg-ab-soft" />)}</div>
    <span className="sr-only">Loading</span>
  </div>
);

export const EmptyState = ({ title = "Nothing here yet", text }) => (
  <div className="card-ab bg-ab-soft p-10 text-center" data-testid="empty-state">
    <p className="font-serif text-xl font-semibold">{title}</p>
    {text && <p className="mt-2 text-sm text-ab-muted">{text}</p>}
  </div>
);
